import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=6bbfc10c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbfc10c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bbfc10c')) {
      api.createRecord('6bbfc10c', component.options)
    } else {
      api.reload('6bbfc10c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=6bbfc10c&scoped=true&", function () {
      api.rerender('6bbfc10c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25WzVhz75a9O0/JS/comp/Accordion.vue"
export default component.exports